<app-dialog
  [title]="data.title"
  [actions]="actions"
  [hideCloser]="data.disableClose"
  (action)="close($event)"
  (close)="close()"
>
  <div class="input-container my-4">
    <div class="input-container_label">{{data.title}}</div>
    <select
      class="input-container_input"
      [formControl]="type"
    >
      <option *ngFor="let item of data.options" [value]="item.id">
        {{ item.name }}
      </option>
    </select>
  </div>
</app-dialog>
